import React from 'react';
import s from './StandardMenuItemLabel.scss';
var StandardMenuItemLabel = function (_a) {
    var _b = _a.item, label = _b.label, complexLabel = _b.complexLabel, newTag = _b.newTag;
    // allows some items to separate visually their text label from option label
    if (complexLabel) {
        return React.createElement(React.Fragment, null, complexLabel);
    }
    var newTagImg = (React.createElement("img", { alt: "new", className: s['menu-item-new-tag'], src: "https://st.deviantart.net/eclipse/promos/newtag.svg" }));
    return typeof label === 'string' ? (React.createElement("span", { className: s['menu-item-text-label'] },
        label,
        newTag ? newTagImg : null)) : (React.createElement(React.Fragment, null, label));
};
StandardMenuItemLabel.displayName = 'StandardMenuItemLabel';
export default StandardMenuItemLabel;
//# sourceMappingURL=StandardMenuItemLabel.js.map